import script from "./RequestForm-Etax.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestForm-Etax.vue?vue&type=script&setup=true&lang=js"

import "./RequestForm-Etax.vue?vue&type=style&index=0&id=bc0f3678&lang=css"

const __exports__ = script;

export default __exports__